import React from 'react'
import { CGE } from '../../../../common/components/CGE';
import { decode_utf8, changeCurrancyFormat } from '../../../../common/utils/utilsFunc';
import { useModal } from "@clayui/modal";

function VulnerableAgreementFormCal({props}) {
    const [values, setValues] = React.useState({})
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });

    React.useEffect(() => {
        if(props.currentPage === "calQuota" && props.state?.detailClient?.ConsultarDetalleCtaCtoResponse) {
            if(props.state?.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                props.setCuentaContratoCuota({
                    canal: props.properties.canal_calcula_tu_cuota, 
                    cuentaContrato: values.idClient, 
                    empresa: props.properties.codigo_empresa,
                    url: props.properties.url_ws_empresa
                });
            }
        }
    }, [props.state?.detailClient?.ConsultarDetalleCtaCtoResponse]);

    React.useEffect(() => {
        if(props.state?.calculaTuCuotaResponse) {
            props.setLoading(false)
            if(props.state?.calculaTuCuotaResponse?.code !== 0) {
                props.setGlobalAlert(props.state?.calculaTuCuotaResponse?.message, "warning", true, "Advertencia");
            }
        }
    }, [props.state?.calculaTuCuotaResponse]);

    let propsLabelInfoContent = {
        "content": props.state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function handleClickButtonClient() {
        if (values.idClient) {
            props.setIdClient(values.idClient);
        } else {
            setInputValidate({ ...inputValidate, ...inputValidate.empty.idClient = true, ...inputValidate.msg.idClient = "Debe ingresar un Nro de Cliente" })
            props.setGlobalAlert(`Complete todos los campos obligatorios.`,"warning");
        }
    }

    function handleMontoCuotaMensal(qtdCuetas) {
        if(props.state?.calculaTuCuotaResponse?.deuda !== undefined && qtdCuetas !== "") {
            const deuda = Number(props.state?.calculaTuCuotaResponse?.deuda);
            const qtd = Number(qtdCuetas);
            const montoCuotaMensual = deuda / qtd;
            setValues({ ...values, dateConsult: changeCurrancyFormat(montoCuotaMensual) });
        }
    }

  return (
    <div id="vulnerableAgreementFormCal">
        <CGE.Panel title={decode_utf8(props.title_3_vulnereble_agreement)} >
            <CGE.PanelSection title={decode_utf8(props.title_section_client)}>
                <div class="row">
                    <div className="col-md-12">
                        <CGE.DetailClient
                            props={{
                                handleChange: (e) => setValues({ ...values, idClient: e.target.value }),
                                hasError: inputValidate?.empty?.idClient,
                                msgError: inputValidate?.msg?.idClient,
                                idClient: values.idClient,
                                idFormElement: "numberClientId",
                                labelName: "N° Cliente:",
                                placeholder: "Número de Cliente",
                                mandatoryElement: true,
                                valuePub: values.idClient,
                                labelButton: "Buscar",
                                handleClick: () => { handleClickButtonClient() },
                                sizeButton: "sm",
                                typeButton: "primary",
                                propsLabelInfoContent:propsLabelInfoContent
                            }}
                            propsDetail={{
                                fullNameClient: (props.detailClientJson?.PRIMER_NOMBRE_PERSONA || props.detailClientJson?.SEGUNDO_NOMBRE_PERSONA
                                    || props.detailClientJson?.APELLIDO_PERSONA) ? values.socialReason = `${props.detailClientJson?.PRIMER_NOMBRE_PERSONA} 
                                    ${props.detailClientJson?.SEGUNDO_NOMBRE_PERSONA} ${props.detailClientJson?.APELLIDO_PERSONA}` : "",
                                comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                                calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                                nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                                dptoBlockClient: (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO) ? `${props.detailClientJson?.SUPLEMENTO} 
                                ${props.detailClientJson?.PISO}` : "",
                                ctaCtoClient: props.detailClientJson?.CTA_CTO
                            }}
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.title_section_solicitante_convenio_vulnerable)}>
                <div className="row">
                    <div className="col-md-6">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, dateConsult: e.target.value })}
                            idFormElement="dateConsult"
                            disabled={true}
                            typeElement="input"
                            labelName="Fecha de la consulta"
                            placeholder="Fecha de la consulta"
                            maxLength="10"
                            hasError={inputValidate?.empty?.dateConsult}
                            msgError={inputValidate?.msg?.dateConsult}
                            value={props.state?.calculaTuCuotaResponse?.fecha}
                        />
                    </div>
                    <div className="col-md-6">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, dateConsult: e.target.value })}
                            idFormElement="dateConsult"
                            disabled={true}
                            typeElement="input"
                            labelName="Deuda acumulada a la fecha de consulta"
                            placeholder="Deuda acumulada a la fecha de consulta"
                            maxLength="10"
                            hasError={inputValidate?.empty?.dateConsult}
                            msgError={inputValidate?.msg?.dateConsult}
                            value={props.state?.calculaTuCuotaResponse?.deuda !== undefined ? changeCurrancyFormat(String(props.state?.calculaTuCuotaResponse?.deuda)) : null}
                        />
                    </div>
                </div>
                {/* webcontent com servicos do back */}
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.title_section_vulnerabilidad_convenio_vulnerable)} >
                <div className="row">
                    <div className="col-md-12">
                        <CGE.FormsField
                            handleChange={(e) => {
                                setValues({ ...values, qtdCuetas: e.target.value });
                                handleMontoCuotaMensal(e.target.value);
                            }}
                            idFormElement="qtdCuetas"
                            mandatoryElement={true}
                            labelName="Seleccione cantidad de cuotas mensuales a convenir (no puede exceder las 48):"
                            typeElement="select"
                            hasError={inputValidate?.empty?.qtdCuetas}
                            msgError={inputValidate?.msg?.qtdCuetas}
                            disabled={props.state?.calculaTuCuotaResponse?.deuda === undefined}
                            value={values.qtdCuetas}
                            listOptions={props.optionsCuetas}
                        />
                    </div>
                    <div className="col-md-12">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, dateConsult: e.target.value })}
                            idFormElement="dateConsult"
                            disabled={true}
                            typeElement="input"
                            labelName="Monto de la cuota mensual"
                            placeholder="Monto de la cuota mensual"
                            maxLength="10"
                            hasError={inputValidate?.empty?.dateConsult}
                            msgError={inputValidate?.msg?.dateConsult}
                            value={values.dateConsult}
                        />
                    </div>
                </div>
                {/* webcontent com servicos do back */}
            </CGE.PanelSection>
        </CGE.Panel>
    </div>
  )
}

export default VulnerableAgreementFormCal;